<app-global-loader></app-global-loader>
<app-sidenavbar *ngIf="isLoggedIn && !isModulesPage && !isSecureViewer"></app-sidenavbar>
<div id="main" [style.margin-left]="isSecureViewer ? '0' : ''">
  <!-- <div class="d-flex"> -->
  <!-- <div *ngIf="!router.url.includes('authentication')" class="resizer" id="resizer"></div>  test-->
  <!-- <div> -->
  <app-header *ngIf="isLoggedIn && !isSecureViewer"></app-header>
  <app-page-loader *ngIf="isLoading"></app-page-loader>
  <app-notif-panel *ngIf="isLoggedIn && !isNotifPanelHide && !isSecureViewer"></app-notif-panel>

  <router-outlet></router-outlet>
  <app-chatbot></app-chatbot>
  <!-- </div> -->
</div>
<!-- </div> -->